export default __webpack_public_path__ + "static/media/it-75.c1f60233.svg";